import React from "react";

const MunuPOPup = ({
  setOpenEditService,
  setOpenMunuPOPup,
  setOpenDelete1,
  setOpenViewTable
}) => {
  return (
    <>
      <div className="menu1 bg-white shadow-sm">
        <div className="px-5 pt-5 ">
          <button
            className="form_btn d-block mb-3 "
            onClick={() => {
              setOpenMunuPOPup(false);
              setOpenEditService(true);
            }}
          >
            Edit
          </button>
          <button
            className="form_btn  form_btn1 d-block mb-3 "
            onClick={() => {
              setOpenMunuPOPup(false);
              setOpenDelete1(true);
            }}
          >
            Delete
          </button>

          <button
            className="form_btn  form_btn2 d-block mb-5 "             onClick={() => {
                setOpenMunuPOPup(false);
                setOpenViewTable(true);
              }}>View</button>
        </div>
      </div>
    </>
  );
};

export default MunuPOPup;
